import * as wemeet from '@tencent/wemeet-js-sdk';
import api from '@/api';

const wemeet_error = async (err)=>{
    console.log('wemeet_error err',err);
    const bizCode = err?.data?.bizCode ?? 0;
    // 用户未授权该应用
    if(bizCode == 1012) {
        const authBaseInfo = await api.user.authBaseInfo();
        wemeet.permission.requestAuth({
            sdkId: authBaseInfo['sdkId'],
            corpId: authBaseInfo['corpId'],
            redirectURI: location.href,
            state: "mmlls",
        });
    }
}

export default wemeet_error;